import SvgIcon from '../SvgIcon/SvgIcon';

function CloseIcon({ ...props }) {
  return (
    <SvgIcon {...props}>
      <polygon points="12 11.1 17.7 5.55 19 6.82 13.46 12.2 19 17.59 17.7 18.86 12 13.31 6.3 18.86 5 17.59 10.54 12.2 5 6.82 6.3 5.55 12 11.1" />
    </SvgIcon>
  );
}

export default CloseIcon;
